import {
    ErrorIcon,
    mergeClasses,
    Text,
    Tile,
    TilesSection,
    useAsyncEffect,
    useStatsTileStyles,
    useTileStyles,
} from "@relode/core";
import * as React from "react";

import { useJobContext } from "../../../_infra";

export const JobEngagement = () => {
    const classes = mergeClasses(useStatsTileStyles({}), useTileStyles({}));

    const statusTile = {
        root: classes.statusTile,
        title: classes.statusTitle,
        content: classes.statusContent,
        paper: classes.tilePaper,
    };
    const {
        state: {
            ui: {
                isJobLoading,
                isJobEngagementFunnelLoading,
                jobEngagementFunnelError,
            },
            data: { currentJobId, job },
        },
        actions,
    } = useJobContext();

    const jobEngagementFunnel = job?.jobEngagementFunnel;

    useAsyncEffect(async () => {
        await actions.loadJobEngagementFunnel(currentJobId);
    }, [currentJobId]);

    const isBusy = isJobLoading || isJobEngagementFunnelLoading;

    const getSubTitleText = (count: number | undefined, label: string) => (
        <>
            <Text variant="h5" isInline={true}>
                {count ?? 0}
            </Text>{" "}
            {label}
        </>
    );

    const displayStat = (value: number | undefined | null) => {
        if (isBusy || value === undefined || value === null) return "n/a";
        return value;
    };

    const getErrorTitleAdornment = () =>
        !!jobEngagementFunnelError ? <ErrorIcon /> : null;

    const getErrorTooltip = () =>
        !!jobEngagementFunnelError
            ? jobEngagementFunnelError.friendlyMessages ??
              "An unexpected error occurred.  Please try again."
            : null;

    return (
        <div>
            <div className={classes.sectionTitleFlex}>
                <Text variant="h2">cloud engagement</Text>
            </div>
            <TilesSection
                usePaper={false}
                classes={{ paper: classes.tilesSectionPaper }}
                className={classes.tilesSection}
            >
                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="JobVisitsContainer"
                    title="views"
                    isBusy={isBusy}
                    subTitle={getSubTitleText(
                        jobEngagementFunnel?.totalUniqueVisits,
                        "unique"
                    )}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(jobEngagementFunnel?.totalVisits)}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="jobFavorites"
                    title="favorites"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(jobEngagementFunnel?.totalFavorites)}
                </Tile>
            </TilesSection>
        </div>
    );
};
